// Explicit synthetic preview data. Never used as component defaults.
import { ART_BASE } from '../assets.js';
const ASSET = ART_BASE;

export const FIXTURE_TONIGHT = [
  { id: 'dishes', title: 'Unload the dishwasher', icon: `${ASSET}/icon-dishes.png`, reward: 0.75, xp: 15, status: 'unlit' },
  { id: 'dog', title: 'Walk Biscuit', icon: `${ASSET}/icon-dog.png`, reward: 1.0, xp: 20, streak: 'streak quest', status: 'unlit' },
  { id: 'bed', title: 'Make your bed', icon: `${ASSET}/icon-bed.png`, reward: 0.5, status: 'pending', note: 'your high-five is on its way ✋' },
  { id: 'plant', title: 'Water the plants', icon: `${ASSET}/icon-plant.png`, reward: 0.5, status: 'done', note: 'Dad high-fived ✦' },
];

export const FIXTURE_TOMORROW = [
  { id: 'laundry', title: 'Fold the laundry', icon: `${ASSET}/icon-laundry.png`, reward: 1.25, when: 'Saturday' },
];

export const todayFixture = {
  tonight: FIXTURE_TONIGHT,
  tomorrow: FIXTURE_TOMORROW,
  kidName: 'Maya',
  streak: 3,
  avatar: `${ASSET}/avatar-kid-1.jpg`,
  walletBalance: 6.25,
  badgesThisWeek: 2,
};
